module.exports = __webpack_public_path__ + "static/media/upload_gallery@3x.37028c40.png";